import React, { useEffect, useState, useRef, createElement } from 'react';
import { X, User, Mail, Phone, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { VslHeader } from '../components/VslHeader';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+39',
  country: 'Italia'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
export function LeadMagnetHeyLloydDemoPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const nameInputRef = useRef<HTMLInputElement>(null);
  const emailInputRef = useRef<HTMLInputElement>(null);
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const areaCodeRef = useRef<HTMLSelectElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    const domName = nameInputRef.current?.value?.trim() || name.trim();
    const domEmail = emailInputRef.current?.value?.trim() || email.trim();
    const domPhone = phoneInputRef.current?.value?.replace(/\D/g, '').trim() || phone.trim();
    const domAreaCode = areaCodeRef.current?.value || areaCode;
    if (!domName || domName.length < 2) {
      alert('Por favor ingresa tu nombre completo');
      return;
    }
    if (!domEmail || !domEmail.includes('@')) {
      alert('Por favor ingresa un email válido');
      return;
    }
    if (!domPhone || domPhone.length < 7) {
      alert('Por favor ingresa tu número de teléfono');
      return;
    }
    setIsSubmitting(true);
    try {
      const webhookUrl = 'https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/9e77fbea-dfb7-4800-9398-1f4c8701198d';
      const payload = {
        name: domName,
        email: domEmail,
        phone: `${domAreaCode}${domPhone}`,
        first_name: domName.split(' ')[0],
        last_name: domName.split(' ').slice(1).join(' ') || domName.split(' ')[0],
        full_name: domName,
        source: '/lead-magnet-heylloyd-demo',
        page_path: '/lead-magnet-heylloyd-demo',
        event_time: Math.floor(Date.now() / 1000),
        action_source: 'website'
      };
      await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      navigate('/thank-you');
    } catch (error) {
      console.error('Error submitting form:', error);
      navigate('/thank-you');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden selection:bg-[#00f7fc] selection:text-black" data-id="element-2993" data-mp="298ycrx70vkg2">
      <noscript data-id="element-2994" data-mp="249lrhgvsulfl">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-2995" data-mp="249u2f38d3go5" />
      </noscript>

      <VslHeader data-id="element-2996" data-mp="2e181xb0bcgha" />

      <main className="relative z-10 max-w-3xl mx-auto px-4 py-12 md:py-20" data-id="element-2997" data-mp="2e0opg9tfmkan">
        <article className="prose prose-invert prose-lg md:prose-xl max-w-none" data-id="element-2998" data-mp="2s0zh3f2kg2wv">
          <h1 className="text-3xl md:text-5xl font-black leading-tight tracking-tight mb-8 text-white" data-id="element-2999" data-mp="2nz5lhl789p3k">
            El Protocolo de 48 Horas: Cómo la IA Construye Negocios Rentables
            Mientras Duermes
          </h1>

          <div className="space-y-6 text-gray-300 leading-relaxed" data-id="element-3000" data-mp="3bkg7tudzi3gj">
            <p data-id="element-3001" data-mp="2xmi19b5wnbbl">
              Si estás leyendo esto, probablemente ya intentaste crear un
              negocio digital. Y probablemente te topaste con el mismo muro que
              el 99% de las personas: la parálisis técnica.
            </p>

            <p data-id="element-3002" data-mp="2nuucxj4naaec">
              No sabes qué vender. No sabes cómo hacer una página web. No sabes
              cómo escribir anuncios que conviertan. Y la idea de pasar meses
              aprendiendo todo esto te agota antes de empezar.
            </p>

            <p data-id="element-3003" data-mp="2iwaptfebeske">
              Aquí está la verdad incómoda: Los emprendedores que están
              facturando $10k, $50k o $100k al mes no son más inteligentes que
              tú. Simplemente dejaron de hacer el trabajo manual.
            </p>

            <p data-id="element-3004" data-mp="29ygti4gjvyx8">
              Hoy, la barrera de entrada es cero. Lo que antes requería un
              equipo de cinco personas y tres meses de trabajo, ahora se ejecuta
              en 48 horas con una sola herramienta de Inteligencia Artificial:
              HEYLLOYD.
            </p>

            <h2 className="text-2xl md:text-3xl font-bold text-white mt-12 mb-8" data-id="element-3005" data-mp="6o3qkrn4ach2">
              Así es exactamente como funciona el sistema (sin experiencia
              previa):
            </h2>

            <div className="space-y-8" data-id="element-3006" data-mp="ye8j5dl165td">
              <div data-id="element-3007" data-mp="udprbjj50zr6">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-3008" data-mp="ud6f8jg655l2">
                  <span className="text-[#00f7fc]" data-id="element-3009" data-mp="ped6t5fqo4rr">1.</span> La IA Encuentra el
                  Dinero (Minuto 1-15)
                </h3>
                <p data-id="element-3010" data-mp="ke7a3aum3s2t">
                  Olvídate de adivinar qué quiere la gente. HEYLLOYD escanea
                  millones de datos en tiempo real y te dice exactamente qué
                  nicho está hambriento hoy, qué problema tienen y cuánto están
                  dispuestos a pagar por la solución. Tienes la certeza
                  matemática antes de empezar.
                </p>
              </div>

              <div data-id="element-3011" data-mp="3015jc7x8i6eq">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-3012" data-mp="2zyjdccpzryym">
                  <span className="text-[#00f7fc]" data-id="element-3013" data-mp="34yyp4zumkyeh">2.</span> La IA Crea el
                  Producto (Hora 1-3)
                </h3>
                <p data-id="element-3014" data-mp="39sjr12zcaciy">
                  No necesitas ser un experto. Basado en la demanda detectada,
                  HEYLLOYD estructura y redacta el producto digital completo
                  (una guía, un curso, un sistema) diseñado específicamente para
                  resolver ese problema urgente.
                </p>
              </div>

              <div data-id="element-3015" data-mp="3spkw0nsw8cmw">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-3016" data-mp="3so03f3q533ro">
                  <span className="text-[#00f7fc]" data-id="element-3017" data-mp="1tcqjoai23ymn">3.</span> La IA Construye la
                  Máquina de Ventas (Hora 4-6)
                </h3>
                <p data-id="element-3018" data-mp="1ybjz48gwlzpg">
                  Aquí es donde la mayoría se rinde. HEYLLOYD usa su función
                  Sales Letter Weapon para redactar y ensamblar una página de
                  ventas de alta conversión. Escribe el titular, la historia, la
                  oferta y los bonos usando fórmulas psicológicas probadas. Cero
                  código. Cero diseño.
                </p>
              </div>

              <div data-id="element-3019" data-mp="8w98c0iwuyuj">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-3020" data-mp="3h9y9n19w7ow0">
                  <span className="text-[#00f7fc]" data-id="element-3021" data-mp="3ha81kuei064c">4.</span> La IA Genera los
                  Anuncios (Hora 7-8)
                </h3>
                <p data-id="element-3022" data-mp="3qaefuii0ta4k">
                  No necesitas grabar videos complicados ni pagar diseñadores.
                  La IA te entrega los guiones exactos para Meta y TikTok, y
                  genera las imágenes publicitarias diseñadas para detener el
                  scroll y conseguir clics baratos.
                </p>
              </div>

              <div data-id="element-3023" data-mp="11iai5ldneokl">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-3024" data-mp="11kwppl0jh42t">
                  <span className="text-[#00f7fc]" data-id="element-3025" data-mp="191jsbgtzarap">5.</span> El Lanzamiento
                  (Hora 48)
                </h3>
                <p data-id="element-3026" data-mp="1e2r0hh019shw">
                  Conectas las piezas, enciendes los anuncios y dejas que el
                  sistema trabaje. Pasaste de una idea en blanco a un negocio
                  operando en el mercado en menos de un fin de semana.
                </p>
              </div>
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-white mt-12 mb-6" data-id="element-3027" data-mp="1ruxfv0vd3vga">
              El Siguiente Paso (Ver Para Creer)
            </h2>

            <p data-id="element-3028" data-mp="1i3t1a29lmclz">
              Leer sobre esto es interesante. Verlo suceder en vivo frente a tus
              ojos te cambiará la perspectiva para siempre.
            </p>

            <p data-id="element-3029" data-mp="2arox74rcg0hp">
              He preparado un Entrenamiento en Vivo y Gratuito donde voy a
              compartir mi pantalla, abrir HEYLLOYD, y construir un negocio
              completo desde cero, paso a paso, usando exactamente este
              protocolo.
            </p>

            <p data-id="element-3030" data-mp="31kfvwzjplnzn">
              Vas a ver la investigación, la creación de la oferta y la página
              de ventas en tiempo real. Sin secretos. Sin teoría. Pura
              ejecución.
            </p>

            <div className="mt-12 text-center" data-id="element-3031" data-mp="2rqqo20bpqxj7">
              <button onClick={() => setShowRegisterModal(true)} className="group relative w-full md:w-auto bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-lg md:text-xl uppercase tracking-wide rounded-xl py-5 px-8 shadow-[0_0_40px_rgba(253,185,49,0.4)] transition-all duration-300 transform hover:scale-[1.02]" data-id="element-3032" data-mp="2wmehwt154ev1">
                Haz clic aquí para registrarte al Entrenamiento en Vivo y ver el
                Sistema en Acción
                <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-3033" data-mp="1z0qidz9e1gfa">
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-[#00D9FF]/60 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-3034" data-mp="23xqouba5gl6x" />
                </div>
              </button>
              <p className="mt-6 text-gray-400 italic" data-id="element-3035" data-mp="1gd7wj8hcdwi4">
                La tecnología ya no es una excusa. Nos vemos dentro.
              </p>
            </div>
          </div>
        </article>
      </main>

      <Footer data-id="element-3036" data-mp="1pas04o2og4vw" />

      {/* Registration Modal */}
      {showRegisterModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowRegisterModal(false)} data-id="element-3037" data-mp="23ajl58rm2lje">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(253,185,49,0.15)]" onClick={e => e.stopPropagation()} data-id="element-3038" data-mp="2d1nwzzlzpqa0">
            <button onClick={() => setShowRegisterModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" data-id="element-3039" data-mp="284x9ir7uvsek">
              <X className="w-6 h-6" data-id="element-3040" data-mp="2i21x8vhcnvxh" />
            </button>

            <div className="text-center mb-6" data-id="element-3041" data-mp="2p48hpbgf0rim">
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase" data-id="element-3042" data-mp="2p5jlhb9v1z9q">
                Completa Tu Registro
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-3043" data-mp="2z24s211j3ifo">
                Ingresa tus datos para asegurar tu cupo gratuito
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-3044" data-mp="33ufqt0kj8y6n">
              {/* Name Input */}
              <div className="space-y-1" data-id="element-3045" data-mp="38rejdeojsx2q">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-3046" data-mp="3ctj942bvl9k3">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-3047" data-mp="3htntw4jtgqg4">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-3048" data-mp="3hqt8a9p2gzl4">
                    <User className="h-5 w-5 text-gray-500" data-id="element-3049" data-mp="3mpct26rxc5bw" />
                  </div>
                  <input ref={nameInputRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required minLength={2} autoComplete="name" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-3050" data-mp="1ngpmpttey9x0" />
                </div>
              </div>

              {/* Email Input */}
              <div className="space-y-1" data-id="element-3051" data-mp="1662779ygad5u">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-3052" data-mp="16367bg31leer">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-3053" data-mp="1ytetdj0p8iym">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-3054" data-mp="1yuhhxkaju9bd">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-3055" data-mp="1tt0k5xnd32z0" />
                  </div>
                  <input ref={emailInputRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required autoComplete="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-3056" data-mp="1ov8rv2it1eua" />
                </div>
              </div>

              {/* Phone Input Group */}
              <div className="space-y-1" data-id="element-3057" data-mp="1sd4xfjb2e48q">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-3058" data-mp="1se6atufjz2tm">
                  WhatsApp / Teléfono
                </label>
                <div className="flex gap-2" data-id="element-3059" data-mp="2l1jy10tg8k0j">
                  {/* Area Code Selector */}
                  <div className="relative w-1/3" data-id="element-3060" data-mp="2q0dcavgk8f1r">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-3061" data-mp="2pz2bn4ievnev">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-3062" data-mp="2b2kxk5iu7uom" />
                    </div>
                    <select ref={areaCodeRef} name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-3063" data-mp="2g0w7shd1o77d">
                      {COUNTRY_CODES.map(country => <option key={country.code} value={country.code} className="bg-gray-900" data-id="element-3064" data-mp="3dvp4jb3qyvdw">
                          {country.code} {country.country}
                        </option>)}
                    </select>
                  </div>

                  {/* Phone Number Input */}
                  <div className="relative w-2/3" data-id="element-3065" data-mp="3nrs366ze4bw3">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-3066" data-mp="305dav7rikokn">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-3067" data-mp="2v6a7rsv3gsfb" />
                    </div>
                    <input ref={phoneInputRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required minLength={7} autoComplete="tel" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-3068" data-mp="38xnm8se5b03h" />
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <button type="submit" disabled={isSubmitting} className="w-full mt-6 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] disabled:opacity-50 disabled:cursor-not-allowed text-black font-black uppercase tracking-wide rounded-xl py-4 shadow-lg hover:shadow-[#FDB931]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-3069" data-mp="kcepb7e7vh38">
                {isSubmitting ? 'PROCESANDO...' : 'CONFIRMAR REGISTRO'}
              </button>

              <p className="text-center text-xs text-gray-500 mt-4" data-id="element-3070" data-mp="6df0nzqpf272">
                Tus datos están 100% seguros y no compartiremos tu información.
              </p>
            </form>
          </div>
        </div>}
    </div>;
}